import { AxiosResponse } from 'axios';

import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from '../../http';
import {
  ICreateServicesData,
  IUpdateServicesData,
  IGetServicesResponse,
  ICreateServiceResponse,
  IGetSingleServiceResponse,
  IGetServicesFilters,
  IDeleteServicesFilters,
} from 'models/http/service';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import DataUploadBaseHttp from './utils/data-upload.http';
import { HTTP } from './core.http';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class ServiceHttp extends DataUploadBaseHttp implements HTTP<IDeleteServicesFilters> {
  protected readonly route: DataUploadModels = ModelsNames.Service;

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async get(filters: IGetServicesFilters, abortController?: AbortController): Promise<IGetServicesResponse['records']> {
    const query = prepareQPFromFilters(filters);

    return serverAxios
      .get(`/${this.route}?${query.toString()}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetServicesResponse>) => {
        return response.data.records;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleServiceResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleServiceResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateServicesData): Promise<string> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateServiceResponse>) => {
        return response.data.id;
      });
  }

  public async delete(ids: number[]): Promise<void>;
  public async delete(filters: IDeleteServicesFilters): Promise<void>;
  public async delete(filters: number[] | IDeleteServicesFilters): Promise<void> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
        timeout: HttpTimeoutPriority.Low,
      })
      .then(() => {
        return;
      });
  }

  public async update(id: number, data: IUpdateServicesData): Promise<void> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then(() => {
        return;
      });
  }
}

export default ServiceHttp;
